/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonContextCto } from '../../models/person-context-cto';
import { UserAssociationUpdateCto } from '../../models/user-association-update-cto';

export interface UpdateUserAssociation$Plain$Params {
  personGuid: string;
      body?: UserAssociationUpdateCto
}

export function updateUserAssociation$Plain(http: HttpClient, rootUrl: string, params: UpdateUserAssociation$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonContextCto>> {
  const rb = new RequestBuilder(rootUrl, updateUserAssociation$Plain.PATH, 'put');
  if (params) {
    rb.path('personGuid', params.personGuid, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonContextCto>;
    })
  );
}

updateUserAssociation$Plain.PATH = '/person/{personGuid}/user-association';
